module.exports = __webpack_public_path__ + "media/images/amenities_icons/trampoline-a66344e44c42be7eb46dc8e16bb427e0.svg";